import { useQuery } from 'react-query';
import { cacheKeys } from './cacheKeys';
import { handleRequest } from '../../redux/services/APIService';

export const useGetAppointmentRequestMessages = (
  options = { appointmentRequestId: '' },
) => {
  return useQuery(
    cacheKeys.getAppointmentRequestMessages(options),
    async () => {
      if (!options?.appointmentRequestId) return [];

      const response = await handleRequest(
        'get',
        `appointment-requests/${options.appointmentRequestId}/messages`,
        true,
        null,
        options.filter,
      );

      return response.data;
    },
    {
      onError: (error) => {
        console.error(
          `${error.response?.data?.data?.resultMessage || error.message}`,
        );
      },
      ...options,
    },
  );
};
